export enum Severity {
    Green = "Green",
    Grey = "Grey",
    Amber = "Amber",
    Red = "Red"
}
